import '../sass/project.scss';
import 'bootstrap5-toggle/js/bootstrap5-toggle.ecmas';
import 'htmx.org';
import './utils/htmxConfig';
import { startAlpineOnce } from './utils/alpineConfig';

import 'daterangepicker/daterangepicker.css';
import 'daterangepicker';

import '@splidejs/splide/css'; // Splide default theme
import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css'; // Import the CSS for Tippy.js
window.tippy = tippy;

import Quill from 'quill';
import 'quill/dist/quill.snow.css';

import { initializeToasts } from './utils/toast';
import { showLoadingSpinner } from './utils/spinner';
import { handleCloseFormClick } from './utils/closeform';
import { updateReferrerFields } from './utils/updatereferrerfields';
import { closeAllForms } from './utils/closeallforms';

//import { showProductTypeDetails } from './utils/showproducttype'; Replaced with Alpine.js
import { addtaxfeefields, addTaxFee } from './utils/addtaxfee';
import { clearFields } from './utils/clearfields';
import './utils/storeLogoPlaceholder';

// Import Alpine Stores
import registerCalendarStore from './alpine_stores/calendarStore';
import registerBookingListStore from './alpine_stores/bookingListStore.js';
import registerProductForm from './alpine_stores/productForm';
import registerToastStore from './alpine_stores/toastStore';
import registerUpdateProductForm from './alpine_stores/updateProductForm';
import registerAddBookingForm from './alpine_stores/addBookingForm';
import registerUpdateBookingForm from './alpine_stores/editBookingItemForm.js';
import registerAddBlockForm from './alpine_stores/addBlockForm.js';
import registerUpdateBlockForm from './alpine_stores/editBlockItemForm.js';
import registerFullBookingStore from './alpine_stores/fullBookingStore';
import registerCartStore from './alpine_stores/cartStore';
import registerStoreCartStore from './alpine_stores/storeCartStore';
import registerStorePages from './alpine_stores/storePagesStore.js';
import registerStoreRateSetStore from './alpine_stores/storeRateSetStore.js';
import registerStoreBookingForm from './alpine_stores/storeBookingForm.js';
import registerSliderStore from './alpine_stores/sliderStore.js';
import registerRateSettingsStore from './alpine_stores/rateSettingsStore.js';
import registerStorePaymentStore from './alpine_stores/storePaymentStore.js';
import registerCalendarSettingsStore from './alpine_stores/calendarSettingsStore.js';
import registerCalendarSettingsIntegrationsStore from './alpine_stores/calendarSettingsIntegrationsStore.js';
import registerCalendarSettingsChannelsStore from './alpine_stores/calendarSettingsChannelsStore.js';
import registerCalendarSettingsDiscountsStore from './alpine_stores/calendarSettingsDiscountsStore.js';
import registerCalendarSettingsResourcesStore from './alpine_stores/calendarSettingsResourcesStore.js';
import registerCalendarSettingsMessagingStore from './alpine_stores/calendarSettingsMessagingStore.js';
import registerCalendarSettingsReportsStore from './alpine_stores/calendarSettingsReportsStore.js';
import registerCalendarSettingsAccountStore from './alpine_stores/calendarSettingsAccountStore.js';
import registerCalendarSettingsOnlineStoreStore from './alpine_stores/calendarSettingsOnlineStoreStore.js';
import registerPackageBuilderStore from './alpine_stores/packageBuilderStore.js';
import registerDayPlannerStore from './alpine_stores/dayPlannerStore.js';
// Remember page location after form submissions (might not need this after integrating htmx to submissions for partials)
window.addEventListener('beforeunload', function () {
  sessionStorage.setItem('scrollPosition', window.scrollY);
});

document.body.addEventListener('htmx:configRequest', function (event) {
  //console.log('Config request:', event.detail);
});

window.updateStoreMobileModalOffset = function () {
  if (!document.body || !document.body.classList.contains('store-body')) {
    return;
  }

  const storeNavbar = document.querySelector(
    'body.store-body .navbar.navbar-expand-lg.navbar-light',
  );
  const fallbackOffset = 90;
  const measuredOffset = storeNavbar
    ? Math.ceil(storeNavbar.getBoundingClientRect().bottom)
    : fallbackOffset;
  const safeOffset = Math.max(measuredOffset, 64);

  document.body.style.setProperty(
    '--store-mobile-modal-top-offset',
    `${safeOffset}px`,
  );
};

window.addEventListener('resize', () => window.updateStoreMobileModalOffset());
window.addEventListener('orientationchange', () =>
  window.updateStoreMobileModalOffset(),
);

window.createStoreMobileSheetState = function (initialExpanded = false) {
  return {
    isExpanded: initialExpanded,
    _sheetMediaQuery: null,
    _syncSheetState: null,
    _mediaQueryCleanup: null,
    init() {
      this._sheetMediaQuery = window.matchMedia('(max-width: 991.98px)');
      this._syncSheetState = () => {
        window.updateStoreMobileModalOffset();
        if (this._sheetMediaQuery.matches) {
          document.body.classList.toggle(
            'store-mobile-sheet-open',
            this.isExpanded,
          );
          return;
        }
        document.body.classList.remove('store-mobile-sheet-open');
      };

      this.$watch('isExpanded', () => this._syncSheetState());
      this._syncSheetState();

      if (this._sheetMediaQuery.addEventListener) {
        this._sheetMediaQuery.addEventListener('change', this._syncSheetState);
        this._mediaQueryCleanup = () =>
          this._sheetMediaQuery.removeEventListener(
            'change',
            this._syncSheetState,
          );
      } else if (this._sheetMediaQuery.addListener) {
        this._sheetMediaQuery.addListener(this._syncSheetState);
        this._mediaQueryCleanup = () =>
          this._sheetMediaQuery.removeListener(this._syncSheetState);
      }
    },
    open() {
      this.isExpanded = true;
    },
    close() {
      this.isExpanded = false;
    },
    toggle() {
      this.isExpanded = !this.isExpanded;
    },
    destroy() {
      if (this._mediaQueryCleanup) {
        this._mediaQueryCleanup();
        this._mediaQueryCleanup = null;
      }
      document.body.classList.remove('store-mobile-sheet-open');
    },
  };
};

function bootstrapAlpineFeatures() {
  if (window.__HT_ALPINE_BOOTSTRAPPED__) {
    return;
  }
  window.__HT_ALPINE_BOOTSTRAPPED__ = true;

  console.log('Project.js: Alpine init event fired');

  // Initiate Alpine Stores
  // General Stores
  registerToastStore();

  // Get the page type from the span element with class 'page-type'
  const pageTypeElement = document.querySelector('.page-type');
  const pageType = pageTypeElement ? pageTypeElement.dataset.pageType : '';
  console.log('Project.js: Page type:', pageType);

  // Online Store Page Stores
  if (pageType === 'store') {
    registerStorePages();
    registerStoreRateSetStore();
    registerStoreCartStore();
  } else if (pageType === 'store-advanced') {
    registerStorePages();
    registerStoreRateSetStore();
    registerStoreBookingForm();
    registerStoreCartStore();
    registerSliderStore();
  } else if (pageType === 'store-rateset') {
    registerStoreRateSetStore();
    registerStoreBookingForm();
    registerStoreCartStore();
    registerSliderStore();
  } else if (pageType === 'store-full-cart') {
    registerStoreCartStore();
  } else if (pageType === 'store-checkout') {
    registerStoreCartStore();
    registerStorePaymentStore();
  } else if (pageType === 'store-extras') {
    registerStoreCartStore();
  } else if (pageType === 'store-request') {
    registerStoreCartStore();
    registerStorePaymentStore();
  } else if (pageType === 'store-payment') {
    registerStoreCartStore();
    registerStorePaymentStore();
  } else if (pageType === 'store-paypal-checkout-expired') {
    registerStoreCartStore();
  } else if (pageType === 'calendar-settings') {
    registerCalendarSettingsStore();
    const settingsPath = window.location.pathname;
    const isPath = (segment) =>
      settingsPath.includes(`/business-settings/${segment}/`) ||
      settingsPath.includes(`/business-settings-v2/${segment}/`);

    if (isPath('account')) {
      registerCalendarSettingsAccountStore();
    } else if (isPath('resources')) {
      registerCalendarSettingsResourcesStore();
    } else if (isPath('online-store')) {
      registerCalendarSettingsOnlineStoreStore();
    } else if (isPath('discounts')) {
      registerCalendarSettingsDiscountsStore();
    } else if (isPath('channels')) {
      registerCalendarSettingsChannelsStore();
    } else if (isPath('messaging')) {
      registerCalendarSettingsMessagingStore();
    } else if (isPath('integrations')) {
      registerCalendarSettingsIntegrationsStore();
    } else if (isPath('reports')) {
      registerCalendarSettingsReportsStore();
    } else if (isPath('pricing-conditions')) {
      if (!Alpine.store('calendarSettingsPricingConditionsStore')) {
        console.warn(
          'calendarSettingsPricingConditionsStore was not preloaded before Alpine started',
        );
      }
    } else {
      // Fallback for unexpected settings paths.
      registerCalendarSettingsAccountStore();
    }
    registerCartStore();
  } else if (pageType === 'calendar-settings-hub') {
    registerCartStore();
  } else if (pageType === 'calendar') {
    registerCalendarStore();
    registerProductForm();
    registerUpdateProductForm();
    registerAddBookingForm();
    registerUpdateBookingForm();
    registerAddBlockForm();
    registerUpdateBlockForm();
    registerCartStore();
  } else if (pageType === 'booking-list') {
    registerBookingListStore();
    registerCartStore();
  } else if (pageType === 'day-planner') {
    registerDayPlannerStore();
    registerCartStore();
  } else if (pageType === 'full-booking') {
    registerFullBookingStore();
    registerCartStore();
  } else if (pageType === 'ratesettings') {
    registerRateSettingsStore();
    registerCartStore();
  } else if (pageType === 'product-settings') {
    registerUpdateProductForm();
    registerCartStore();
  } else if (pageType === 'user-detail') {
    registerCartStore();
  } else if (pageType === 'plans') {
    registerCartStore();
  } else if (pageType === 'package-builder') {
    registerPackageBuilderStore();
    registerCartStore();
  }

  // Initiate Tippy
  Alpine.magic('tooltip', (el) => (message) => {
    tippy(el, { content: message, allowHTML: true });
  });

  Alpine.directive('tooltip', (el, { expression }) => {
    tippy(el, { content: expression, allowHTML: true });
  });

  Alpine.directive('tippy', (el, { expression, modifiers }, { effect }) => {
    let tippyInstance = null;
    let content = '';

    const placementModifiers = ['top', 'bottom', 'left', 'right'];
    const modifierPlacement =
      placementModifiers.find((name) => modifiers.includes(name)) || 'top';

    // Evaluate content and update if tooltip exists
    effect(() => {
      content = Alpine.evaluate(el, expression);
      if (!content) {
        if (tippyInstance) {
          tippyInstance.destroy();
          tippyInstance = null;
        }
        return;
      }
      if (!tippyInstance) {
        const placement =
          el.getAttribute('data-tippy-placement') || modifierPlacement;
        tippyInstance = tippy(el, {
          content: content,
          allowHTML: true,
          zIndex: 9999,
          placement,
          trigger: 'mouseenter focus',
          hideOnClick: false,
        });
      } else {
        tippyInstance.setContent(content);
      }
    });

    // Cleanup function
    el._x_removeTippy = () => {
      if (tippyInstance) {
        tippyInstance.destroy();
        tippyInstance = null;
      }
    };
  });
}

function isPricingConditionsSettingsPage() {
  const pageType = document.querySelector('.page-type')?.dataset?.pageType;
  if (pageType !== 'calendar-settings') {
    return false;
  }
  const settingsPath = window.location.pathname;
  return (
    settingsPath.includes('/business-settings/pricing-conditions/') ||
    settingsPath.includes('/business-settings-v2/pricing-conditions/')
  );
}

async function preloadPricingConditionsStoreIfNeeded() {
  if (!isPricingConditionsSettingsPage()) {
    return;
  }
  if (Alpine.store('calendarSettingsPricingConditionsStore')) {
    return;
  }
  registerToastStore();
  registerCalendarSettingsStore();
  registerCartStore();
  const { default: registerCalendarSettingsPricingConditionsStore } =
    await import('./alpine_stores/calendarSettingsPricingConditionsStore.js');
  registerCalendarSettingsPricingConditionsStore();
}

document.addEventListener('alpine:init', bootstrapAlpineFeatures);

function waitForDocumentReady() {
  if (document.readyState !== 'loading') {
    return Promise.resolve();
  }
  return new Promise((resolve) => {
    document.addEventListener('DOMContentLoaded', resolve, { once: true });
  });
}

async function bootAlpine() {
  await waitForDocumentReady();
  await preloadPricingConditionsStoreIfNeeded();

  // Start Alpine only after alpine:init listeners are registered.
  const startedByThisBundle = startAlpineOnce();
  if (!startedByThisBundle) {
    // Alpine was already running; ensure stores/directives still register.
    bootstrapAlpineFeatures();
  }
}

bootAlpine();

function handleSlideFormSubmissions() {
  // Select forms that are descendants of elements with the 'slideForm' class
  let slideForms = document.querySelectorAll('.slideForm form');

  slideForms.forEach(function (form) {
    form.addEventListener('submit', function (e) {
      //e.preventDefault();  // Prevent the default form submission behavior
      closeAllForms();
      showLoadingSpinner();
    });
  });
}

function handleAddTaxFee(e) {
  e.preventDefault();
  addTaxFee();
}

// ADD EVENT LISTENERS
document.addEventListener('DOMContentLoaded', () => {
  window.updateStoreMobileModalOffset();
  const elementsActions = {
    closeSlideFormBtn: handleCloseFormClick,
    backDrop: handleCloseFormClick,
    addTaxFeeButton: handleAddTaxFee,
  };

  Object.keys(elementsActions).forEach((key) => {
    const elements = document.querySelectorAll(`.${key}`);
    elements.forEach((element) => {
      element.addEventListener('click', elementsActions[key]);
    });
  });

  handleSlideFormSubmissions();
  addtaxfeefields();
  initializeToasts();
  clearFields();
});
